import React, { useState, useEffect, useRef } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje, MensajeSiNo } from "../mensajes";
import axios from "axios";
import { ActualizarPresupuesto } from "./modalActuPresupuestos";

const TablaPresupuesto = (props) => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  let municipios = [];

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CÓDIGO",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "AUXILIAR",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCIÓN",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [presupuesto, setPresupuesto] = useState();
  const [catpro, setCatpro] = useState();
  const [claspre, setClaspre] = useState();
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.catpuc.includes(target.value) ||
              x.auxiliar.toLowerCase().includes(target.value.toLowerCase()) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarRegistros = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/registrodecuentaspresupuestarias?id=${idefiscal}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var datos = [];
          var nomcat;
          var nompuc;
          var fusion;
          var fusiondos;
          var cat;
          var puc;

          for (let i = 0; i < response.data.length; i++) {
            nomcat = response.data[i].descripcap.trim();
            nompuc = response.data[i].descripuc.trim();
            fusion = nomcat + "(" + nompuc + ")";

            cat = response.data[i].categoriaprogramatica.trim();
            puc = response.data[i].puc.trim();
            fusiondos = cat + "(" + puc + ")";

            datos.push({
              idcuenta: response.data[i].idcuenta,
              descripcion: fusion,
              catpuc: fusiondos,
              auxiliar: response.data[i].auxiliar,
            });
          }
          setRecords(datos);

          /* setRecords(response.data); */
          txtBuscador.current.focus();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarPresupuesto = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "cuentapresupuestaria";
    let nomid = "idcuenta";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idcuenta > 0) {
            setPresupuesto(response.data);
            seleccionarCatProgramatica(response.data);
          } else {
            setPresupuesto();
            seleccionarCatProgramatica(response.data);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarCatProgramatica = (data) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "categoriaprogramatica";
    let nomid = "idcategoriaprogramatica";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idcategoriaprogramatica}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idcategoriaprogramatica > 0) {
            setCatpro(response.data);
            seleccionarClasPresupuestario(data);
          } else {
            setCatpro();
            seleccionarClasPresupuestario(data);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarClasPresupuestario = (data) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "puc";
    let nomid = "idpuc";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idpuc}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idpuc > 0) {
            setClaspre(response.data);
            setMostrar2(true);
          } else {
            setClaspre();
            setMostrar2(true);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
  };

  const gestionarCtaPresupuestaria = (op, id) => (e) => {
    if (op === 4) {
      setOperacion(4);
      SeleccionarPresupuesto(id);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true);
    } else if (op === 2) {
      setOperacion(op);
      SeleccionarPresupuesto(id);
    }
  };

  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  };

  return (
    <div className="h-100 w-100">
      <div className="row col-md-12 m-0">
        <div className="row col-md-12 m-0">
          <div className="col-md-8 py-3">
            <div className="col-12 p-2">
              <div className="row col-12 d-flex justify-content-between">
                <input
                  type="text"
                  className=" col-3 form-control form-control-sm rounded-pill"
                  ref={txtBuscador}
                  onChange={handleSearch}
                  placeholder="Buscar"
                />
                <div className="col-3 d-flex justify-content-end">
                  <button
                    onClick={gestionarCtaPresupuestaria(1, "")}
                    style={{ marginBottom: "5px" }}
                    className="btn btn-sm btn-primary rounded-circle"
                  >
                    <i className="fas fa-plus"></i>{" "}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-12 m-0">
              <TblContainer>
                <TblHead />
                <TableBody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <TableRow
                        key={index + item.idcuenta}
                        style={{ padding: "0" }}
                      >
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            width: "120px",
                          }}
                        >
                          {item.catpuc}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            width: "50px",
                          }}
                        >
                          {item.auxiliar}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            width: "250px",
                          }}
                        >
                          {item.descripcion}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            width: "50px",
                          }}
                        >
                          <button
                            onClick={gestionarCtaPresupuestaria(
                              4,
                              item.idcuenta
                            )}
                            className="btn btn-sm mx-1 btn-info rounded-circle"
                          >
                            <i className="fas fa-eye"></i>{" "}
                          </button>
                          <button
                            onClick={gestionarCtaPresupuestaria(
                              2,
                              item.idcuenta
                            )}
                            className="btn btn-sm mx-1 btn-success rounded-pill"
                          >
                            <i className="fas fa-sync-alt"></i> Reversar
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
          <div className="col-md-4 py-3"></div>
        </div>
      </div>
      <ActualizarPresupuesto
        show={mostrar2}
        operacion={operacion}
        presu={presupuesto}
        categoria={catpro}
        claspre={claspre}
        onHideCancelar={handleCancelar}
        onHideRenderizar={SeleccionarRegistros}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />
    </div>
  );
};
export default TablaPresupuesto;



// WEBPACK FOOTER //
// ./src/components/presupuesto/tablapresupuesto.js